import { Overlay } from '@angular/cdk/overlay';
import { DomPortal } from '@angular/cdk/portal';
import { DestroyRef, ElementRef, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type FullscreenRef = { onClose: Subject<void>; close: () => void };

@Injectable({ providedIn: 'root' })
export class FullscreenService {
  constructor(private overlay: Overlay) {}

  fullscreenElement(element: ElementRef, destroyRef: DestroyRef): FullscreenRef {
    const ref = this.overlay.create({
      height: '100vh',
      width: '100vw',
      panelClass: 'dt-fullscreen-panel',
      backdropClass: 'dummy',
      hasBackdrop: true,
    });

    const closeSubject = new Subject<void>();

    const close = () => {
      ref.dispose();
      closeSubject.next();
      closeSubject.complete();
    };

    ref.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();

        close();
      }
    });

    ref.backdropClick().subscribe(event => {
      event.preventDefault();
      event.stopPropagation();

      close();
    });

    destroyRef.onDestroy(() => {
      close();
    });

    const domPortal = new DomPortal(element);
    ref.attach(domPortal);

    return {
      onClose: closeSubject,
      close,
    };
  }
}
